import { computed } from 'vue'
import type { DocumentsState } from './state'

export const createGetters = (state: DocumentsState) => {
  const documentCount = computed(() => state.documents.length)

  const publicDocuments = computed(() => {
    return state.documents.filter((d) => d.isPublic)
  })

  const internalDocuments = computed(() => {
    return state.documents.filter((d) => !d.isPublic)
  })

  const documentsByType = computed(() => {
    const grouped: Record<string, typeof state.documents> = {}
    state.documents.forEach((doc) => {
      if (!grouped[doc.type]) {
        grouped[doc.type] = []
      }
      grouped[doc.type].push(doc)
    })
    return grouped
  })

  const sharedDocuments = computed(() => {
    return state.documents.filter((d) => d.shareMode !== 'none' && d.shareToken)
  })

  const getShareUrl = (shareToken: string): string => {
    return `${window.location.origin}/public/doc/${shareToken}`
  }

  return {
    documentCount,
    publicDocuments,
    internalDocuments,
    documentsByType,
    sharedDocuments,
    getShareUrl,
  }
}
